import { gql, useQuery } from '@apollo/client';
import { customerDoctorFragment } from '../../GraphQL/Fragments/customer';
import { useRouting } from '../../Common/hooks/useRouting';
import { useEffect } from 'react';
import { pusherSubscribeObject } from '../../Common/utils/pusher';

export const GET_CUSTOMER = gql`
  ${customerDoctorFragment}
  query getCustomerBrandQuery($id: ID) {
    getCustomerBrand(id: $id) {
      ...customerDoctorFragment
    }
  }
`;

export const useDoctorCustomer = () => {
  let {
    params: { customerID },
  } = useRouting();

  const { loading, refetch, data } = useQuery(GET_CUSTOMER, {
    fetchPolicy: 'cache-and-network',
    variables: {
      id: customerID,
    },
  });

  useEffect(() => {
    const { unsubscribe } = pusherSubscribeObject(customerID ?? '', 'customer', () => refetch());

    return () => {
      unsubscribe();
    };
  }, [customerID]);

  return {
    customerID,
    customer: data?.getCustomerBrand,
    loading,
  };
};
